import HistoryOverview from '../components/dashboard/HistoryOverview'

const HistoryPage = () => <HistoryOverview />

export default HistoryPage
